import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

/**
 * App-level TanStack Form wiring. `useAppForm` replaces `useForm` for forms that
 * embed shared field groups; `withFieldGroup` defines a reusable cluster of
 * fields that can be mounted into forms of different overall shapes (e.g. the
 * company and section forms). No field/form components are registered — our
 * groups use the render-prop `group.Field` with `@ui/themed` inputs inline.
 */
const { fieldContext, formContext } = createFormHookContexts();

export const { useAppForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
});
